// Data for general questions
const GeneralData = {
  rows: [
    {
      title: "What is alcohol?",
      content:
        "Ethyl alcohol, or ethanol, is an intoxicating ingredient found in beer, wine, and liquor. Alcohol is produced by the fermentation of yeast, sugars, and starches",
    },
    {
      title: "Why do people drink alcohol?",
      content:
        "To enhance sociability, to increase power, to escape problems, to get drunk, for enjoyment, or for ritualistic reasons",
    },

    {
      title: "What's the equivalent of one drink of alcohol?",
      content:
        "In the USA, one drink is equivalent to 14 grams of pure alcohol, which is generally equal to 12 oz of beer, 5 oz of wine, and 1.5 fl oz of a spirit. It may vary depending on the alcohol content of the beverage.!",
    },
    {
      title: "Is alcohol a drug?",
      content:
        "Yes, alcohol is a drug. In fact, it is one of the most commonly used drugs.",
    },
    {
      title: "How can I know if I may have a drinking problem?",
      content:
        `According to Mount Sinai, you may have a drinking problem if you are unable to stop drinking, spend a lot of time drinking, you experience symptoms of withdrawl when you stop drinking, and you can only think about the urge to drink. There are many other symptoms of having a drinking problem. To learn more, please click <a href="https://www.mountsinai.org/health-library/report/alcohol-use-disorders">here</a>.`,
    },
    {
      title: "What is binge drinking?",
      content:
        "According to the National Institute on Alcohol Abuse and Alcoholism, binge drinking is defined as a pattern of drinking alcohol that brings blood alcohol concentration (BAC) to 0.08 percent—or 0.08 grams of alcohol per deciliter—or higher. ",
    },
    {
      title: "What is Blood Alcohol Concentration (BAC)?",
      content:
        "Blood Alcohol Concentration (BAC) refers to the percentage of alcohol in a person's blood stream. For example, if you have a BAC of .10%, this means that an individual's blood supply contains one part alcohol for every 1000 parts blood.",
    },
  ],
};

// Data for the health questions
const HealthData = {
  rows: [
    {
      title: "How long does it take for alcohol to be metabolized in the body?",
      content:
        "On average, it takes about one hour for one standard drink of alcohol to be metabolized by the body. This is dependent on many factors.",
    },
    {
      title: "How long will it take to feel the effects of alcohol?",
      content:
        "It may take an hour to metabolize a drink, but it takes approximately thirty minutes before you feel alcohol’s effects.",
    },
    {
      title: "How can alcohol make me feel?",
      content:
        "Even though alcohol may make you feel good, it is still a depressant, which dehydrates you. It is important to make sure you stay hydrated!",
    },
    {
      title: "What are quick ways for me to get sober while drinking?",
      content: "You can't. The only thing that will sober you up is time.",
    },
    {
      title: "Can I sleep the alcohol off if I start to feel sick?",
      content:
        "The worst thing a severely intoxicated person can do is lie down. If you vomit, you could actually choke and die. If you are with someone who is intoxicated and must lie down, make sure the person is lying on his/her side and his/her head is turned to the side then watch the person closely.",
    },
    {
      title: "How do I know if I have alcohol poisoning?",
      content:
        "According to the National Institute on Alcohol Abuse and Alcoholism, the symptoms of alcohol overdose include mental confusion, difficulty remaining conscious, vomiting, seizure, trouble breathing, slow heart rate, clammy skin, dulled responses such as no gag reflex (which prevents choking), and extremely low body temperature. Alcohol overdose can lead to permanent brain damage or death. If you believe you or someone you are with may have alcohol poisoning, please call 911. ",
    },
  ],
};

// Data about drinking practices
const DrinkData = {
  rows: [
    {
      title:
        "What does it mean to order a drink “neat”, “up” or “on the rocks?",
      content:
        "When you order a spirit “neat,” it means you just want the booze poured straight into the glass with no ice or added flavorings. Ordering a drink “on the rocks” will get you a straight spirit or cocktail poured over ice in a lowball glass. Ordering a drink “up” means you want it chilled and strained without ice into a stemmed cocktail glass.",
    },
    {
      title: "What’s a 'twist'?",
      content:
        "A twist refers to a swath of citrus peel—usually lemon, orange or grapefruit with no white pith—that’s twisted over a drink.",
    },
    {
      title: "What’s in simple syrup?",
      content:
        "Simple syrup is equal parts granulated sugar and water. It is used to sweeten drinks, and it is easily customizable with other flavors.",
    },
    {
      title: "What’s a “chaser” or “back?",
      content:
        "'Chaser' and 'back' are synonymous, both referring to something taken after a shot of liquor, to dull the burning sensation and cleanse the palate.",
    },
    {
      title:
        "What does it mean to order a Martini or Manhattan dry, wet, perfect, etc.?",
      content:
        "This refers to the amount of vermouth you want in a Martini or Manhattan. Dry doesn’t mean using dry vermouth—it means using less vermouth. Wet conversely means adding in more vermouth.",
    },
    {
      title: "How long should you shake a cocktail?",
      content:
        "You should typically shake a cocktail for at least 10 seconds. ",
    },
    {
      title: "How long should you stir a cocktail?",
      content: "You should typically stir a cocktail for at least 10 seconds. ",
    },
  ],
};

module.exports = { GeneralData, DrinkData, HealthData };
